export const PROFILE_UPDATED_EVENT = 'kichat:profile-updated';
